import React, {useContext, useState, useEffect} from 'react';
import NovoQuestionario from '../../components/Questionarios/NovoQuestionario';
import Table from '../../components/Questionarios/Table';
import DrawerFilter from '../../components/Questionarios/DrawerFilter';
import {useTranslation} from 'react-i18next';
import {Context} from '../../Helpers/Auth';
import {getRepresentantes, getSimNao} from '../requests';

function Questionarios() {
    const {t} = useTranslation();
    const {path, setPath} = useContext(Context);
    const [loading, setLoading] = useState(false);

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    // Apresenta form de Questionarios ou não
    const [showForm, setShowForm] = useState(false);

    // Questionario que está selecionado
    const [questionarioSelecionado, setQuestionarioSelecionado] = useState('');

    // flag para guardar Questionario
    const [guardarQuestionario, setGuardarQuestionario] = useState(false);

    // Indica se o form está em modo de edição ou não
    const [editarQuestionario, setEditarQuestionario] = useState(false);

    // flag com indicação de se foram efetuados alterações no prospect
    const [onChangeForm, setOnChangeForm] = useState(false);

    //FILTROS
    const [filtroNumero, setFiltroNumero] = useState('');
    const [filtroCliente, setFiltroCliente] = useState('');
    const [filtroData, setFiltroData] = useState({startDate: null, endDate: null});
    const [filtroDescricao, setFiltroDescricao] = useState('');
    const [filtroVendedor, setFiltroVendedor] = useState(null);
    const [filtroNegocio, setFiltroNegocio] = useState('');
    const [filtroValidado, setFiltroValidado] = useState('');

    const [representantes, setRepresentantes] = useState([]);
    const [simNao, setSimNao] = useState([]);

    useEffect(() => {
        getRepresentantes(lang).then(res => {
            setRepresentantes(res.data.representantes);
        });

        getSimNao(lang).then(res => {
            setSimNao(res.data.simNao);
        });
    }, []);

    const handleRowClick = dados => {
        setQuestionarioSelecionado(dados);
        setShowForm(true);
        setEditarQuestionario(false);
        setOnChangeForm(false);
    };

    useEffect(() => {
        if (showForm && !questionarioSelecionado) {
            setPath(t('novoQuestionario'));
        } else if (showForm && questionarioSelecionado) {
            setPath(t('editarQuestionario') + ' ' + questionarioSelecionado.id + ' - ' + questionarioSelecionado.descricao);
        } else {
            setPath('');
        }
    }, [path, showForm]);

    return (
        <>
            <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                <div className="flex flex-row justify-end dark:text-gray-400 text-gray-500">
                    <DrawerFilter
                        questionarioSelecionado={questionarioSelecionado}
                        setQuestionarioSelecionado={setQuestionarioSelecionado}
                        filtroNumero={filtroNumero}
                        setFiltroNumero={setFiltroNumero}
                        filtroCliente={filtroCliente}
                        filtroData={filtroData}
                        setFiltroData={setFiltroData}
                        filtroDescricao={filtroDescricao}
                        setFiltroDescricao={setFiltroDescricao}
                        // setFiltroCidade={setFiltroContacto}
                        setFiltroCliente={setFiltroCliente}
                        filtroVendedor={filtroVendedor}
                        setFiltroVendedor={setFiltroVendedor}
                        filtroNegocio={filtroNegocio}
                        setFiltroNegocio={setFiltroNegocio}
                        onChangeForm={onChangeForm}
                        showForm={showForm}
                        setShowForm={setShowForm}
                        editarQuestionario={editarQuestionario}
                        setEditarQuestionario={setEditarQuestionario}
                        setGuardarQuestionario={setGuardarQuestionario}
                        guardarQuestionario={guardarQuestionario}
                        filtroValidado={filtroValidado}
                        setFiltroValidado={setFiltroValidado}
                        representantes={representantes}
                        simNao={simNao}
                    />
                </div>
                
            </div>

            {!showForm && (
                <Table
                    loading={loading}
                    setLoading={setLoading}
                    filtroNumero={filtroNumero}
                    setFiltroNumero={setFiltroNumero}
                    filtroCliente={filtroCliente}
                    setFiltroCliente={setFiltroCliente}
                    filtroData={filtroData}
                    setFiltroData={setFiltroData}
                    filtroDescricao={filtroDescricao}
                    setFiltroDescricao={setFiltroDescricao}
                    filtroVendedor={filtroVendedor}
                    setFiltroVendedor={setFiltroVendedor}
                    filtroNegocio={filtroNegocio}
                    setFiltroNegocio={setFiltroNegocio}
                    filtroValidado={filtroValidado}
                    setFiltroValidado={setFiltroValidado}
                    onRowClick={handleRowClick}
                    representantes={representantes}
                    simNao={simNao}
                />
            )}

            {showForm && (
                <NovoQuestionario
                    questionarioSelecionado={questionarioSelecionado}
                    loading={loading}
                    setLoading={setLoading}
                    setGuardarQuestionario={setGuardarQuestionario}
                    guardarQuestionario={guardarQuestionario}
                    setShowForm={setShowForm}
                />
            )}
        </>
    );
}

export default Questionarios;
